import React, { useCallback, useRef } from 'react';
import { useMapEvent } from 'react-leaflet';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { updateLastCenter } from '../../redux/actions';

const MapURLParams = React.memo(() => {
  const timer = useRef(null);
  const history = useHistory();
  const dispatch = useDispatch();

  const onMoveEnd = useCallback(
    ({ target: map }) => {
      const zoom = map.getZoom();
      const center = map.getCenter();
      timer.current = setTimeout(() => {
        dispatch(updateLastCenter([center.lat, center.lng]));
        history.push(`/${center.lat}/${center.lng}/${zoom}`);
      }, 500);
    },
    [history, dispatch]
  );

  const onMoveStart = useCallback(() => {
    if (timer.current) {
      clearTimeout(timer.current);
    }
  }, []);

  useMapEvent('moveend', onMoveEnd);
  useMapEvent('movestart', onMoveStart);
  return null;
});

MapURLParams.displayName = 'MapURLParams';

export default MapURLParams;
